import React from 'react';
import FeaturePageTemplate from '../components/FeaturePageTemplate';

const DataSourcesPage = () => {
  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
    </svg>
  );

  const benefits = [
    "Connect to a wide range of data sources with minimal configuration",
    "Centralized monitoring across relational and NoSQL databases",
    "Seamless integration with modern data warehouses and analytics platforms",
    "Zero-code setup for most common data sources",
    "Scalable connection management for enterprise environments"
  ];

  const details = [
    {
      title: "Relational Database Support",
      description: "Qupid offers comprehensive support for all major relational database management systems, allowing you to monitor and analyze data quality across your entire SQL ecosystem.",
      items: [
        "Oracle - Full support for all modern versions, including Oracle Cloud",
        "PostgreSQL - Complete integration with both self-hosted and cloud PostgreSQL instances",
        "MySQL - Comprehensive compatibility with MySQL and MariaDB deployments",
        "SQL Server - Enterprise-grade support for Microsoft SQL Server environments"
      ]
    },
    {
      title: "NoSQL Database Integration",
      description: "Monitor and manage quality in your document databases with Qupid's NoSQL support.",
      items: [
        "MongoDB - Complete support for MongoDB collections and documents",
        "Integration with MongoDB Atlas and self-hosted deployments",
        "Document validation and schema enforcement capabilities"
      ]
    },
    {
      title: "Analytics & Data Warehouse Platforms",
      description: "Qupid integrates seamlessly with modern data analytics platforms and warehouses to provide end-to-end data quality monitoring.",
      items: [
        "DeltaLake with Glue and Hive catalog support",
        "Complete Hive integration for data lake quality monitoring",
        "Iceberg support with multiple catalog flavors (Glue, Hive, JDBC, Nessie, REST, Snowflake)",
        "Kafka streaming data monitoring",
        "Snowflake warehouse comprehensive integration"
      ]
    }
  ];

  const useCases = [
    {
      title: "Enterprise Data Ecosystem Management",
      description: "Monitor data quality across a complex enterprise environment with multiple database types and data warehouses, ensuring consistency and reliability throughout."
    },
    {
      title: "Data Lake Quality Governance",
      description: "Implement robust quality controls across your data lake environment, whether using Delta Lake, Iceberg, or other modern formats."
    },
    {
      title: "Streaming Data Validation",
      description: "Ensure data quality in real-time for Kafka streams before data reaches downstream applications and analytics platforms."
    },
    {
      title: "Warehouse Migration Quality Assurance",
      description: "Validate data consistency and integrity when migrating between warehouse solutions, such as from traditional databases to Snowflake."
    }
  ];

  return (
    <FeaturePageTemplate
      title="Data Source Integration"
      description="Qupid offers a comprehensive set of data platform integrations covering the majority of use cases across relational databases, NoSQL systems, analytics platforms, and data warehouses."
      icon={icon}
      benefits={benefits}
      details={details}
      useCases={useCases}
      additionalContent={
        <div className="bg-gray-50 p-8 rounded-lg">
          <h3 className="text-2xl font-bold mb-4">Connection Architecture</h3>
          <p className="mb-4">
            Qupid's connection architecture is designed for security, scalability, and ease of management. Our platform uses read-only connections by default to ensure your data remains secure, with options for custom permission models when needed.
          </p>
          <p>
            All connections are encrypted with industry-standard protocols, and credentials are stored in an encrypted vault. Connection pooling ensures optimal performance even when monitoring hundreds of data sources simultaneously.
          </p>
        </div>
      }
    />
  );
};

export default DataSourcesPage; 